/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/CommonFieldType.yaml
/** @hidden */
export const CommonFieldTypeValues = [
    'ID',
    'SURNAME',
    'MAIDEN_NAME',
    'GIVEN_NAMES',
    'BIRTH_DATE',
    'NATIONALITY',
    'BIRTHPLACE',
    'EXPIRY_DATE',
    'EYE_COLOR',
    'HEIGHT',
    'ISSUE_DATE',
    'ISSUING_AUTHORITY',
    'ADDRESS',
    'PSEUDONYM',
    'MRZ',
    'ISSUING_COUNTRY',
    'GENDER',
    'SIGNATURE',
    'PHOTO',
    'VALID_FROM_DATE',
    'ROUTING_NUMBER',
    'ACCOUNT_NUMBER',
    'PLACE_OF_ISSUE',
    'TITLE_TYPE',
    'REMARKS',
    'NAME',
    'CARD_ACCESS_NUMBER',
    'PERSONAL_ID',
];
//# sourceMappingURL=CommonFieldType.js.map